import React from "react";

export default function Container({ styles, children }) {

    return (
        <div className={`max-w-screen-xl px-[20px] w-full mx-auto ${styles}`}>
            {children}
        </div>
    )
}